var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loadingTheme)?_c('div',{class:{'loading-theme': _vm.loadingTheme},attrs:{"id":"app"}},[_c('div',{staticClass:"main"},[_c('router-view')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }